/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-15 17:38:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-03-07 18:18:59
 * @FilePath: \baishu_react_ui\src\Login\BsyRadioGroup\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import { BsyUtils } from '../../utils/Utils';
import BsyRadioGroup from '../BsyRadioGroup';
import BsyTextTag from '../BsyTextTag';
import './index.css';

class BsyCheckGroup extends BsyRadioGroup {


    constructor(props) {
        super({
            ...props,
            type: "checkboxgroup",
        });

    }

    // 当 props 更新时调用
    componentWillReceiveProps(nextProps) {
        // 检查 props 是否有变化
        if (JSON.stringify(this.state.value) !== JSON.stringify(nextProps.value)) {
            // 将 props 的值同步到 state
            this.setState({
                value: nextProps.value,
            });
            this.value = nextProps.value
        }
    }


    _doItemClick = (val) => {
        const { items, value } = this.state;
        let newValue = [];
        if (Array.isArray(value)) {
            newValue = [...value]
        }


        let p = newValue.indexOf(val.value)
        if (p > -1) {
            newValue.splice(p, 1);
        } else {
            newValue.push(val.value);
        }
        this.value = newValue;
        this.setState({
            // items: newItems,
            value: newValue,
        }, () => {
            // this.value = newValue;
            BsyUtils.applyFunc(this, this.props.onStopEdit, [newValue, null, this], !1)
        })

    }

    _createItem = (item, index) => {
        const { layout, value } = this.state

        if (this.props.onItemCreate) {
            let ref = BsyUtils.applyFunc(this, this.props.onItemCreate, [item, index], !1) //this.props.onItemCreate(item, index);
            if (ref !== false)
                return ref
        }


        return <div className={'bsy-group-item bsy-check ' + layout + ((Array.isArray(value) && value.indexOf(item.value) > -1) ? ' select' : '')}
            key={'check-item-' + index}
            onClick={() => {
                this._doItemClick(item);
            }}  >
            <i className="icon-bsy-check2"></i>
            {
                this.props.colorEnable ? <>{item.color ? <BsyTextTag
                    customCls={" middle single-line"}
                    text={item.text}
                    color={item.color}
                > </BsyTextTag> : <span className="bsy-text-tag  middle single-line"
                    style={{ color: "#333", background: "#f5f6f7" }}
                >{item.text}</span>}</> : <span>{item.text}</span>
            }
        </div>
    }

    renderDisablePane = (items, index) => {
        const { value } = this.state;
        const { colorEnable } = this.props;
        return <div className="bsy_form_item_disable" data-watermark={React.language('content.empty')} title={value} ref={this.element} >
            {
                colorEnable ? items.map((item, index) => {
                    return (Array.isArray(value) && value.indexOf(item.value) > -1) ? <BsyTextTag
                        customCls={" middle single-line"}
                        text={item.text}
                        color={item.color}
                    > </BsyTextTag> : ""
                }) : (value ? value.join(',') : '')
            }
        </div>
    }
}

export default BsyCheckGroup;
